<script lang="ts">
  import ViewUserComponent from '../../components/charity/user/ViewUser.svelte';
  
  export let params: { id: string };
</script>

<ViewUserComponent userId={params.id} />

